module.exports = __webpack_public_path__ + "img/qwello-stations-iphone.6c8a239b.png";